import { Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useState } from "react";
import { FaUserEdit } from "react-icons/fa";
import { EditUserModal } from "./Modals";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "150px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
}));

function Profile(props) {
  const classes = useStyles();
  const [editModal, setEditModal] = useState(false);
  const { user } = props;

  const handleOpenModal = () => {
    setEditModal(true);
  };
  const handleCloseModal = () => {
    setEditModal(false);
  };

  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.tabHeading}>My Profile</h2>
        <IconButton onClick={handleOpenModal}>
          <FaUserEdit />
        </IconButton>
      </Box>

      {user.user ? (
        <Box>
          <p>
            Hello <span className={classes.userName}>{user.user.name}</span>,
          </p>
          <Typography variant="subtitle2" mb={5}>
            From your My Profile Dashboard you have the ability to view a
            snapshot of your recent account activity and update your account
            information.
          </Typography>

          <div style={{ marginTop: "30px" }}>
            <Box className={classes.contactBox}>
              <h3 className={classes.subHead}>Email</h3>
              <p style={{ margin: 0 }}>{user.user.email}</p>
            </Box>
            <Box className={classes.contactBox}>
              <h3 className={classes.subHead}>Phone No</h3>
              <p style={{ margin: 0 }}>{user.phone}</p>
            </Box>
          </div>
        </Box>
      ) : (
        <Box>
          <Skeleton />
        </Box>
      )}
      {user.user && (
        <EditUserModal
          visible={editModal}
          closeModal={handleCloseModal}
          userId={user._id}
          name={user.user.name}
          phone={user.phone}
        />
      )}
    </div>
  );
}
export default Profile;
